import { FunctionComponent } from 'react'
import clsx from 'clsx'
import { Box, Button, Typography, CircularProgress } from '@mui/material'
import { Translation } from '@dxp-module/common'
import submitButtonStyles from './submitButton.styles'

type SubmitButtonProps = {
  disabled?: boolean
  loading?: boolean
}

const SubmitButton: FunctionComponent<SubmitButtonProps> = ({
  disabled,
  loading,
}) => {
  const styles = submitButtonStyles()

  return (
    <Box className={styles.root}>
      <Typography variant="caption">
        <Translation id="trans__insurance__insapp_insurance_form__required_fields_label" />
      </Typography>
      <Button
        className={clsx([
          styles.button,
          {
            [styles.disabled]: disabled,
          },
        ])}
        variant="contained"
        color="primary"
        type="submit"
        disableRipple={true}
        disabled={disabled || loading}
        data-test={'myaccount:myinsurance:submit'}
      >
        <Typography className={styles.caption} variant="h6">
          {loading && <CircularProgress size={15} className={styles.loader} />}
          {!loading && (
            <Translation id="trans__insurance__insapp_insurance_form__next_button_label" />
          )}
        </Typography>
      </Button>
    </Box>
  )
}

export default SubmitButton
